import React, { useState, useEffect, useCallback } from "react";
import LoadingInComponent from "../../Components/LoadingInComponent";
import { useToast } from "../../Components/Toast";
import axios from "axios";
import { GET_CHANGE_LOG_LIST_API } from "../../Constant/api";
import Breadcrumb from "../../Components/Breadcrumb";
import ChangeLogTable from "../../Components/Tables/ChangeLogListTable";

const ChangeLog = () => {
  const [loading, setLoading] = useState(false);
  const [changeLogData, setChangeLogData] = useState([]);
  const [changeLogMeta, setChangeLogMeta] = useState();
  const [searchTerm, setSearchTerm] = useState("");
  const [isSearchCleared, setIsSearchCleared] = useState(false);
  const [perPage, setPerPage] = useState(10);

  const { toast } = useToast();

  const fetchChangeLogData = useCallback(async (page = 1, itemsPerPage = perPage) => {
    setLoading(true);

    axios
      .get(GET_CHANGE_LOG_LIST_API, {
        headers: {
          Authorization: `Bearer ${sessionStorage.getItem("bearer_token")}`,
        },
        params: {
          page: page,
          event_id: sessionStorage.getItem("event_id"),
          perPage: itemsPerPage,
          search: searchTerm,
        },
      })
      .then((response) => {
        setLoading(false);
        setChangeLogData(response.data.data);
        setChangeLogMeta(response.data.meta.pagination);
      })
      .catch((error) => {
        console.error("Error fetching change logs:", error);
        setLoading(false);
        toast("Failed to fetch change logs.", "error");
      });
  }, [perPage, searchTerm, toast]);

  const handlePerPageChange = (e) => {
    setPerPage(e.target.value);
    fetchChangeLogData(1, e.target.value);
  };

  const clearFilter = () => {
    setSearchTerm("");
    setIsSearchCleared(true);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      fetchChangeLogData();
    }
  };

  const handlePageClick = (e) => {
    const selectedPage = e.selected + 1;
    fetchChangeLogData(selectedPage);
  };

  useEffect(() => {
    fetchChangeLogData();
  }, [fetchChangeLogData]);

  useEffect(() => {
    if (isSearchCleared && searchTerm === "") {
      fetchChangeLogData();
      setIsSearchCleared(false);
    }
  }, [isSearchCleared, searchTerm, fetchChangeLogData]);

  const breadcrumbItems = [{ label: "Change Log" }, { label: "List" }];

  return (
    <div className="flex flex-col w-full h-full">
      <LoadingInComponent isLoading={loading}>
        {!loading && (
          <div className="flex flex-col w-full h-full p-[16px] md:p-[32px] no-scrollbar overflow-y-auto gap-[24px]">
            {/* Breadcrumb */}
            <Breadcrumb items={breadcrumbItems} />

            {/* Title row */}
            <div className="flex w-full justify-between items-center">
              <h2 className="text-[29px]">Change Log</h2>
            </div>

            {/* List table */}
            <div className="w-full">
              <ChangeLogTable
                data={changeLogData}
                meta={changeLogMeta}
                searchTerm={searchTerm}
                handleSearch={handleSearch}
                handleKeyDown={handleKeyDown}
                handlePageClick={handlePageClick}
                perPage={perPage}
                handlePerPageChange={handlePerPageChange}
                clearFilter={clearFilter}
              />
            </div>
          </div>
        )}
      </LoadingInComponent>
    </div>
  );
};

export default ChangeLog;
